"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var react_tracking_1 = require("react-tracking");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var elog = require("../../elog");
var constants_1 = require("../../constants");
var user_context_helpers_1 = require("../../user_context_helpers");
var sanitized_render_1 = require("../../components/sanitized_render");
var listings_collection_1 = require("../../components/listings_collection");
var rql_1 = require("../../rql");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
var user_context_provider_1 = require("../../components/user_context_provider");
var COMPONENT_NAME = 'RecentlyViewedListings';
var DEFAULT_COUNT = 12;
var MIN_COUNT = 4;
function saleMaxCount(onSale, maxCount) {
    return (onSale ? 20 : maxCount);
}
var RecentlyViewedListings = /** @class */ (function (_super) {
    tslib_1.__extends(RecentlyViewedListings, _super);
    function RecentlyViewedListings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RecentlyViewedListings, "defaultProps", {
        get: function () {
            return {
                maxCount: DEFAULT_COUNT,
                loggedOutExperiment: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    RecentlyViewedListings.prototype.componentDidMount = function () {
        this.tryLogViewEligible();
    };
    RecentlyViewedListings.prototype.componentDidUpdate = function (oldProps) {
        var newListings = lodash_1.get(this.props, 'data.recentlyViewedListings', []);
        var oldListings = lodash_1.get(oldProps, 'data.recentlyViewedListings', []);
        if (!lodash_1.isEqual(newListings, oldListings)) {
            this.tryLogViewEligible();
        }
    };
    RecentlyViewedListings.prototype.tryLogViewEligible = function () {
        if (!this.props.loggedOutExperiment)
            return;
        if (!this.hasEnoughListings())
            return;
        if (!this.props.user.loggedOut)
            return;
        this.props.tracking.trackEvent({
            eventType: tracker_1.VIEW,
            componentName: COMPONENT_NAME + "-LoggedOutExp",
            ids: this.listings().map(function (listing) { return listing.id; })
        });
    };
    RecentlyViewedListings.prototype.hasEnoughListings = function () {
        return !this.loading() && this.listings().length >= MIN_COUNT;
    };
    RecentlyViewedListings.prototype.renderCTA = function () {
        if (!this.props.ctaTargetHref) {
            return;
        }
        return (React.createElement(core_link_1.default, { className: this.props.displayAsGrid && 'button button--orange', to: this.props.ctaTargetHref, interactionType: tracker_1.CTA }, this.props.ctaText
            ? this.props.ctaText
            : I18n.t('cms.listingsCollection.seeMore')));
    };
    RecentlyViewedListings.prototype.saleListings = function () {
        var listings = lodash_1.get(this.props, 'data.recentlyViewedListings');
        var salesListings = listings.filter(function (listing) {
            var reason = lodash_1.get(listing, 'pricing.ribbon.reason', '');
            return reason === rql_1.core_apimessages_Ribbon_Reason.SALE;
        });
        return salesListings.slice(0, this.props.maxCount - 1);
    };
    RecentlyViewedListings.prototype.loading = function () {
        return lodash_1.get(this.props, 'data.loading');
    };
    RecentlyViewedListings.prototype.listings = function () {
        var listings = lodash_1.get(this.props, 'data.recentlyViewedListings');
        if (this.props.onSale && listings) {
            return this.saleListings();
        }
        return listings || [];
    };
    RecentlyViewedListings.prototype.loggedOutExperimentHoldout = function () {
        if (!this.props.loggedOutExperiment)
            return false;
        if (!this.props.user.loggedOut)
            return false;
        return !user_context_helpers_1.isExperimentEnabled(this.props.user, constants_1.experiments.ITEM_LOGGED_OUT_RECENTLY_VIEWED);
    };
    RecentlyViewedListings.prototype.renderTitle = function () {
        if (!this.props.title)
            return null;
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    RecentlyViewedListings.prototype.render = function () {
        try {
            if (!this.hasEnoughListings()) {
                return null;
            }
            if (this.loggedOutExperimentHoldout()) {
                return null;
            }
            return (React.createElement(listings_collection_1.default, { callToAction: this.renderCTA(), componentName: COMPONENT_NAME, displayAsGrid: this.props.displayAsGrid, largeTiles: this.props.largeTiles, listings: this.listings(), loading: this.loading(), maxCount: this.props.maxCount, title: this.renderTitle(), jumplinkSlug: this.props.jumplinkSlug }));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    RecentlyViewedListings = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.LISTING_TYPE,
                context: {
                    title: props.title,
                    maxCount: props.maxCount,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                }
            };
        })
    ], RecentlyViewedListings);
    return RecentlyViewedListings;
}(React.Component));
exports.RecentlyViewedListings = RecentlyViewedListings;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_Cms_RecentlyViewedListings(\n      $limit: Int\n      $loggedOut: Boolean!\n    ) {\n      recentlyViewedListings(input: {\n        limit: $limit\n      }) {\n        ... ListingsCollection\n        ... LoggedInFields @skip(if: $loggedOut)\n      }\n    }\n    ", "\n    ", "\n  "], ["\n    query Commons_Cms_RecentlyViewedListings(\n      $limit: Int\n      $loggedOut: Boolean!\n    ) {\n      recentlyViewedListings(input: {\n        limit: $limit\n      }) {\n        ... ListingsCollection\n        ... LoggedInFields @skip(if: $loggedOut)\n      }\n    }\n    ", "\n    ", "\n  "])), listings_collection_1.default.fragments.listing, listings_collection_1.default.fragments.loggedInFields), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            limit: saleMaxCount(ownProps.onSale, ownProps.maxCount) || DEFAULT_COUNT,
            loggedOut: !!lodash_1.get(ownProps.user, 'loggedOut'),
        }
    }); },
});
exports.default = user_context_provider_1.withUserContext(connect(RecentlyViewedListings));
var templateObject_1;
//# sourceMappingURL=recently_viewed_listings.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/recently_viewed_listings.js
// module id = 5+FE
// module chunks = 0 1 2 6 8 11 12 20